// extracted by mini-css-extract-plugin
export default {"ButtonFontFamily":"ButtonFontFamily_ButtonFontFamily__nals-"};